// extracted by mini-css-extract-plugin
module.exports = {"screenReadrText":"CloseButton_screenReadrText__229fo","icon":"CloseButton_icon__1M3Mf"};